var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Navigate, Route, Routes, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { setIsWaitingRoomOpen, fetchEpisodesThunk, fetchDetectThunk, getMeThunk, loginUserThunk, logoutUserThunk, selectEventId, selectMaintenance, selectUser, selectSelectedEpisodeId, selectIsWaitingRoomOpen, selectAreEpisodesLoading, selectRegisteredSelectEpisode, selectVirtual, selectLoadingDetect, setEpisodes, selectLogin, selectIsLoadingLanguage, selectPublishedApp, selectLocaleLanguage, selectAppContent, selectLogout, selectMe, setLoadingDetect, displayModal, resetUserActionState, UserStateAction, changePlayerSource, changeEpisodeQAEnableStatus, setAgendaLiveStatus, selectChatVendor, selectChatLicense, selectUnsubscribeSubscriber, fetchPreviewThunk, addNotification, selectHasNotifications, selectCurrentEpisode, setEvaluationFormPopupOpenList, setEvaluationFormEnableStatusList, setIsLoadingEpisodes, LoadingStates, setDrawerType, setMobileDrawerOpen, fetchMediaThunk, selectPublicConfig
// selectEvaluationFormEnableList
 } from "@adm-media/adam-store-plugin";
import { PageLayout } from "./components/wrappers/PageLayout/PageLayout";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { isEmpty } from "./utils/obj-check";
import { message } from "antd";
import { subscribeToPusherChannel } from "./pusher/subscribe-to-pusher-channel";
import { subscribeToPublicVodChannel } from "./pusher/subscribe-to-public-vod-channel";
import { clearVodAccessRevoked, setVodAccessRevoked } from "./utils/vodAccessStore";
import { useSetCurrentEpisode } from "./hooks/useSetCurrentEpisode";
import { Spin } from "./components/ui/Spin/Spin";
import { VW_MODAL } from "./components/modals";
import { LocaleChangeOmitCall, useChangeAppLocale } from "./hooks/useChangeAppLocale";
import { useInitializeGtm } from "./hooks/useInitializeGtm";
import { useShowInitialModal } from "./hooks/useInitialmodal";
import { useLoadFonts } from "./hooks/useLoadFonts";
import { useAppDispatch } from "./store";
import { useSetFavicon } from "./hooks/useSetFavicon";
import { useSetNetworkStatus } from "./hooks/useSetNetworkStatus";
import { LiveChatWidget } from "@livechat/widget-react";
import { ErrorPage, EpisodeProposalPage, VideotestPage, PublicQandAPage, HomePage, MaintenancePage, WaitingRoomPage, WatchPage, ChangePasswordPage, ChairmanPage, ModeratorPage, ResetPasswordPage, UnsubscribePage, Paths, ConferencePage, PathQueryParams, PageDetailPage } from "./pages";
import ModalsConnect from "./components/modals/ModalsProvider";
import { useHandleErrors } from "./hooks/useHandleErrors";
import { EpisodeSelectedWrapper } from "./components/wrappers/EpisodeSelectedWrapper/EpisodeSelectedWrapper";
import init from "./pusher/base";
import { useSetWebsiteTitle } from "./hooks/useSetWebsiteTitle";
import { useSetDocumentVisibilityStatus } from "./hooks/useSetDocumentVisibilityStatus";
import { fallbackNotificationMessage, useLogoutIfOffline } from "./hooks/useLogoutIfOffline";
import { useWriteOnDOM } from "./hooks/useWriteOnDOM";
import { subscribeToPusherNotificationChannel } from "./pusher/subscribe-to-notification-channel";
import { useCustomCss } from "./hooks/useCustomCss";
import { isChannelConference } from "./utils/isChannelConference";
import { PusherMock } from "pusher-js-mock";
import { useNotification } from "./hooks/useNotification";
import { useModeratorPusherConnection } from "./hooks/useModeratorPusherConnection";
import { subscribeToEvaluationFormPusherChannel } from "./pusher/subscribe-to-evaluation-form-channel";
import { useIsEvaluationFormPopupOpen } from "./hooks/useIsEvaluationFormPopupOpen";
import { useDeleteQuery } from "./hooks/useDeleteQuery";
import { ScrollToTop } from "./components/functional/ScrollToTop/ScrollToTop";
import { DetectErrorType, getDetectErrorType } from "./utils/get-detect-error-type";
import { WarningOutlined } from "@ant-design/icons";
export var App = function (_a) {
    var _b;
    var previewCode = _a.previewCode;
    var dispatch = useAppDispatch();
    var navigate = useNavigate();
    var _c = useLocation(), pathname = _c.pathname, search = _c.search;
    var eventId = useSelector(selectEventId);
    var virtualWorld = useSelector(selectVirtual);
    var maintenance = useSelector(selectMaintenance);
    var isAppPublished = useSelector(selectPublishedApp);
    var currentLocale = useSelector(selectLocaleLanguage);
    var loadingDetect = useSelector(selectLoadingDetect);
    var chatVendor = useSelector(selectChatVendor);
    var chatLicense = useSelector(selectChatLicense);
    var isWaitingRoomOpen = useSelector(selectIsWaitingRoomOpen);
    var selectedEpisodeId = useSelector(selectSelectedEpisodeId);
    var loadingEpisodes = useSelector(selectAreEpisodesLoading);
    var eventHasNotifications = useSelector(selectHasNotifications);
    var channel = useSelector(selectCurrentEpisode).channel;
    var notification = useNotification().notification;
    var publicConfigs = useSelector(selectPublicConfig);
    var loadingLogin = useSelector(selectLogin).loading;
    var loadingLogout = useSelector(selectLogout).loading;
    var loadingMe = useSelector(selectMe).loading;
    var loadingUnsubscribeSubscriber = useSelector(selectUnsubscribeSubscriber).loading;
    var contents = useSelector(selectAppContent);
    var _d = useSelector(selectUser), token = _d.token, identity = _d.identity, isModerator = _d.isModerator, isChairman = _d.isChairman;
    var changeAppLocale = useChangeAppLocale().changeAppLocale;
    var _e = useState(null), pusherChannel = _e[0], setPusherChannel = _e[1];
    var _f = useState(null), pusherPublicVodChannel = _f[0], setPusherPublicVodChannel = _f[1];
    var _g = useState(null), pusherNotificationChannel = _g[0], setPusherNotificationChannel = _g[1];
    var _h = useState(null), pusherEvaluationFormChannel = _h[0], setPusherEvaluationFormChannel = _h[1];
    var _j = useState(null), playerChannelActions = _j[0], setPlayerChannelActions = _j[1];
    var _k = useState(null), detectErrorType = _k[0], setDetectErrorType = _k[1];
    var setCurrentEpisode = useSetCurrentEpisode().setCurrentEpisode;
    var deleteQuery = useDeleteQuery().deleteQuery;
    var _l = useSearchParams(), setSearchParams = _l[1];
    var isIframeRoute = pathname === "/iframe";
    var iam = new URLSearchParams(search).get("iam");
    var isLoggedIn = !!(identity === null || identity === void 0 ? void 0 : identity.email) && !!token;
    var mustChangePassword = typeof (identity === null || identity === void 0 ? void 0 : identity.change_password_required) === "number" && (identity === null || identity === void 0 ? void 0 : identity.change_password_required) !== 0;
    var shouldRenderWaitingRoom = selectedEpisodeId && isWaitingRoomOpen;
    var shouldRenderConference = isChannelConference(channel);
    var shouldRenderVW = isLoggedIn && !virtualWorld.active && virtualWorld.has && !isModerator && !isChairman;
    var isLoadingRegisterSelectedEpisode = useSelector(selectRegisteredSelectEpisode).isLoading;
    var isLoadingLanguage = useSelector(selectIsLoadingLanguage);
    var isLoadingDetect = loadingDetect === "pending" || loadingDetect === "uninitialized";
    var isLoadingEpisodes = loadingEpisodes === "pending" || loadingEpisodes === "uninitialized";
    var isLoadingLogout = loadingLogout === "pending";
    var isLoadingMe = loadingMe === "pending";
    var isLoadingUnsubscribeSubscriber = loadingUnsubscribeSubscriber === "pending";
    var isLoading = isLoadingRegisterSelectedEpisode ||
        isLoadingLanguage ||
        isLoadingDetect ||
        isLoadingEpisodes ||
        isLoadingLogout ||
        isLoadingMe ||
        isLoadingUnsubscribeSubscriber;
    var pathElements = pathname === null || pathname === void 0 ? void 0 : pathname.split("/");
    var isUnsubscribeRoute = (pathElements === null || pathElements === void 0 ? void 0 : pathElements[1]) === "unsubscribe" && typeof (pathElements === null || pathElements === void 0 ? void 0 : pathElements[2]) === "string";
    var isPageDetailRoute = (_b = pathname === null || pathname === void 0 ? void 0 : pathname.startsWith(Paths.pageDetail)) !== null && _b !== void 0 ? _b : false;
    var goToWatchPlayerRoute = isLoggedIn &&
        !mustChangePassword &&
        selectedEpisodeId &&
        pathname !== Paths.watchPlayer &&
        pathname !== Paths.videotest &&
        !isPageDetailRoute &&
        !isModerator &&
        !isChairman &&
        !isUnsubscribeRoute;
    var goToEpisodeProposalRoute = isLoggedIn &&
        !mustChangePassword &&
        !selectedEpisodeId &&
        pathname !== Paths.watch &&
        pathname !== Paths.videotest &&
        !isPageDetailRoute &&
        !isModerator &&
        !isChairman &&
        !isUnsubscribeRoute;
    var goToChairmanRoute = isChairman && !isIframeRoute && pathname !== Paths.chairman && !mustChangePassword && !isUnsubscribeRoute;
    var goToModeratorRoute = isModerator && !isIframeRoute && pathname !== Paths.moderator && !mustChangePassword && !isUnsubscribeRoute;
    var goToForcedPasswordChange = mustChangePassword && pathname !== Paths.changePassword && !isUnsubscribeRoute;
    useCustomCss();
    useLogoutIfOffline(isChairman || isModerator);
    useSetDocumentVisibilityStatus();
    useSetWebsiteTitle();
    useInitializeGtm();
    useLoadFonts();
    useShowInitialModal();
    useSetFavicon();
    useSetNetworkStatus();
    useHandleErrors();
    useWriteOnDOM();
    useModeratorPusherConnection();
    useIsEvaluationFormPopupOpen();
    var detect = function () {
        setDetectErrorType(null);
        dispatch(fetchDetectThunk())
            .unwrap()
            .catch(function (error) { return setDetectErrorType(getDetectErrorType(error)); });
    };
    useEffect(function () {
        if (loadingDetect === "uninitialized") {
            if (previewCode) {
                dispatch(fetchPreviewThunk(previewCode))
                    .unwrap()
                    .then()
                    .catch(function () {
                    navigate(Paths.home);
                    detect();
                });
            }
            else {
                detect();
            }
        }
        else if (loadingDetect === "succeeded") {
            if (token) {
                dispatch(getMeThunk())
                    .unwrap()
                    .then(function (payload) {
                    if (!!(payload === null || payload === void 0 ? void 0 : payload.lang_id) && (payload === null || payload === void 0 ? void 0 : payload.lang_id) !== currentLocale) {
                        changeAppLocale({ newLocale: payload.lang_id, callsToSkip: [LocaleChangeOmitCall.episodes] });
                    }
                })
                    .catch(function () {
                    // Clean up edl
                    deleteQuery(PathQueryParams.edl);
                });
            }
            else {
                if (!iam)
                    dispatch(fetchEpisodesThunk());
            }
            dispatch(setLoadingDetect("idle"));
        }
        else if (loadingDetect === "failed") {
            // This is set to overwrite basic loading state set on episodes fetch (in store)
            dispatch(setIsLoadingEpisodes(LoadingStates.failed));
        }
    }, [loadingDetect, token, previewCode]);
    /* Setting current episode id from param */
    var _m = useState(null), currentEpisodeIdFromParams = _m[0], setCurrentEpisodeIdFromParams = _m[1];
    var _o = useState(false), initialEpisodeIdSet = _o[0], setInitialEpisodeIdSet = _o[1];
    useEffect(function () {
        if (eventId && currentEpisodeIdFromParams && initialEpisodeIdSet === false) {
            setInitialEpisodeIdSet(true);
        }
    }, [initialEpisodeIdSet, currentEpisodeIdFromParams, eventId]);
    // This will globally handle fetch media if conditions are met
    // in our case we want to fetch new media if we have the public config
    // and only after a login, because on refresh "detect" holds media value
    useEffect(function () {
        // @ts-ignore
        if (loadingLogin === (LoadingStates.succeeded || LoadingStates.idle) && (publicConfigs === null || publicConfigs === void 0 ? void 0 : publicConfigs.reloadMediaAfterLogin)) {
            dispatch(fetchMediaThunk()).unwrap().then().catch();
        }
    }, [loadingLogin, publicConfigs]);
    /** Direct login (iam) */
    useEffect(function () {
        if (!Boolean(eventId))
            return;
        if (!isLoggedIn && iam) {
            dispatch(loginUserThunk({ email: iam, force: true }))
                .unwrap()
                .then(function (payload) {
                var _a, _b, _c;
                if (!!((_a = payload === null || payload === void 0 ? void 0 : payload.me) === null || _a === void 0 ? void 0 : _a.lang_id) && ((_b = payload === null || payload === void 0 ? void 0 : payload.me) === null || _b === void 0 ? void 0 : _b.lang_id) !== currentLocale) {
                    changeAppLocale({ newLocale: ((_c = payload === null || payload === void 0 ? void 0 : payload.me) === null || _c === void 0 ? void 0 : _c.lang_id) || "en", callsToSkip: [LocaleChangeOmitCall.episodes] });
                }
            })
                .catch(function () {
                message.error(contents.waiting_room_accept_message || "An error has occurred");
                dispatch(fetchEpisodesThunk());
                navigate(Paths.home);
            });
        }
    }, [eventId]);
    useEffect(function () {
        var _a, _b;
        var _c, _d, _e, _f, _g;
        var episodeId;
        var episodeDirectLink = new URLSearchParams(search).get(PathQueryParams.edl);
        var efoLink = new URLSearchParams(search).get("efo");
        if (episodeDirectLink) {
            try {
                var episodeDirectLinkDecoded = atob(episodeDirectLink);
                var episodeIdString = episodeDirectLinkDecoded.toString();
                var edlNumber = parseInt(episodeIdString);
                episodeId = edlNumber && !Number.isNaN(edlNumber) ? edlNumber - 1981 : null;
                if (episodeId)
                    setCurrentEpisodeIdFromParams(episodeId);
            }
            catch (_h) { }
        }
        var episodeIdLoaded = eventId ? episodeId === null || episodeId === void 0 ? void 0 : episodeId.toString() : null;
        if (loadingLogin === "succeeded" || (loadingMe === "succeeded" && token)) {
            var episodesFromIdentity = Array.isArray(identity === null || identity === void 0 ? void 0 : identity.episodes)
                ? identity === null || identity === void 0 ? void 0 : identity.episodes
                : Object.values((identity === null || identity === void 0 ? void 0 : identity.episodes) || {});
            dispatch(setEpisodes(episodesFromIdentity));
            if (loadingLogin === "succeeded")
                dispatch(resetUserActionState(UserStateAction.login));
            if (loadingMe === "succeeded")
                dispatch(resetUserActionState(UserStateAction.me));
            if (identity.is_chairman || identity.is_moderator)
                return;
            // Condition goToForcedPasswordChange because user cannot be navigated first to edl if needs to change psw
            if (token && episodesFromIdentity.length === 1 && !selectedEpisodeId) {
                setCurrentEpisode({ episodeId: (_c = episodesFromIdentity === null || episodesFromIdentity === void 0 ? void 0 : episodesFromIdentity[0]) === null || _c === void 0 ? void 0 : _c.id });
                // Prevent to navigate further
                if (goToForcedPasswordChange)
                    return;
                if (previewCode) {
                    setSearchParams(__assign((_a = {}, _a[PathQueryParams.edl] = ((_e = (_d = episodesFromIdentity === null || episodesFromIdentity === void 0 ? void 0 : episodesFromIdentity[0]) === null || _d === void 0 ? void 0 : _d.edl) === null || _e === void 0 ? void 0 : _e.toString()) || "", _a), (previewCode ? { preview: previewCode.toString() } : {})));
                }
                else {
                    var path = (_b = {}, _b[PathQueryParams.edl] = ((_g = (_f = episodesFromIdentity === null || episodesFromIdentity === void 0 ? void 0 : episodesFromIdentity[0]) === null || _f === void 0 ? void 0 : _f.edl) === null || _g === void 0 ? void 0 : _g.toString()) || "", _b);
                    if (efoLink) {
                        path = __assign(__assign({}, path), { efo: efoLink });
                    }
                    setSearchParams(path);
                }
            }
            else if (token && episodesFromIdentity.length > 1 && episodeIdLoaded && !selectedEpisodeId) {
                var episodeId_1 = parseInt(episodeIdLoaded);
                if (!Number.isNaN(episodeId_1)) {
                    var thereIsEpisode = episodesFromIdentity.find(function (episode) { return episode.id === episodeId_1; });
                    if (thereIsEpisode) {
                        setCurrentEpisode({ episodeId: episodeId_1 });
                    }
                }
            }
        }
        else if (!token && selectedEpisodeId) {
            setCurrentEpisode({ episodeId: null });
        }
    }, [loadingLogin, loadingMe, token, identity, goToForcedPasswordChange, previewCode]);
    useEffect(function () {
        if (shouldRenderVW)
            dispatch(displayModal({ name: VW_MODAL }));
    }, [shouldRenderVW]);
    /**
     * Execute user logout with notification info
     * @param skip - skip will not execute the logout
     * @returns void
     */
    var logoutWithConnectionError = function (skip) {
        if (skip === void 0) { skip = false; }
        if (skip)
            return;
        dispatch(logoutUserThunk())
            .unwrap()
            .finally(function () {
            notification.info({ message: contents.offline_forced_logout_notification_message || fallbackNotificationMessage });
        });
    };
    var _p = useState(null), pusherSingleton = _p[0], setPusherSingleton = _p[1];
    var _q = useState(0), connectedCounter = _q[0], setConnectedCounter = _q[1];
    useEffect(function () {
        if (!isEmpty(identity) && token && eventId && pusherSingleton === null) {
            if (!(window === null || window === void 0 ? void 0 : window.Cypress)) {
                var pusher = init(token);
                setPusherSingleton(pusher);
                pusher.connection.bind("connected", function () { return setConnectedCounter(function (prev) { return prev + 1; }); });
                pusher.connection.bind("unavailable", function () { return logoutWithConnectionError(isChairman || isModerator); });
                pusher.connection.bind("failed", function () { return logoutWithConnectionError(isChairman || isModerator); });
            }
            else
                setPusherSingleton(new PusherMock());
        }
        else if (pusherSingleton && !token && pusherChannel === null) {
            // https://pusher.com/docs/channels/using_channels/connection/#disconnecting-from-channels
            // https://github.com/pusher/pusher-js/issues/281
            try {
                pusherSingleton.disconnect();
            }
            catch (_a) { }
            setPusherSingleton(null);
        }
    }, [identity, token, eventId, pusherSingleton, pusherChannel, isChairman, isModerator]);
    // This test if user is connection is restablished and token is still valid
    useEffect(function () {
        if (connectedCounter > 1) {
            dispatch(getMeThunk());
        }
    }, [connectedCounter]);
    useEffect(function () {
        var _a;
        if (!isEmpty(identity) && token && eventId && !pusherChannel && pusherSingleton) {
            setPusherChannel(subscribeToPusherChannel({
                pusherSingleton: pusherSingleton,
                config: { appId: eventId, userId: identity.id, subscriptionId: (_a = identity === null || identity === void 0 ? void 0 : identity.subscription) === null || _a === void 0 ? void 0 : _a.code },
                endSessionCallback: function () {
                    dispatch(logoutUserThunk());
                    deleteQuery(PathQueryParams.edl);
                },
                waitingRoomAcceptedCallback: function () {
                    message.success(contents.waiting_room_accept_message || "You have been acceptepted");
                    dispatch(setIsWaitingRoomOpen(false));
                },
                channelStatusChangeCallback: function (data) {
                    dispatch(changePlayerSource(data));
                    setPlayerChannelActions(data);
                },
                qaStatusChangeCallback: function (status) {
                    dispatch(changeEpisodeQAEnableStatus(status.actions));
                },
                agendaLiveStatusChangeCallback: function (status) {
                    console.log("agendaLiveStatusChangeCallback", status);
                    dispatch(setAgendaLiveStatus(status));
                }
            }));
            setPusherPublicVodChannel(subscribeToPublicVodChannel({
                pusherSingleton: pusherSingleton,
                appId: eventId,
                onVodDisabled: function (payload) {
                    if ((payload === null || payload === void 0 ? void 0 : payload.subscriber_id) !== identity.id)
                        return; // channel is shared — only my events
                    setVodAccessRevoked(payload.episode_id, payload.channel_id, !!payload.can_watch_vod);
                }
            }));
        }
        else if (pusherChannel && !token) {
            try {
                pusherChannel.unsubscribe();
            }
            catch (_b) { }
            setPusherChannel(null);
            setPusherPublicVodChannel(function (prev) {
                try {
                    prev === null || prev === void 0 ? void 0 : prev.unsubscribe();
                }
                catch (_a) { }
                return null;
            });
            clearVodAccessRevoked();
            dispatch(fetchEpisodesThunk());
            dispatch(setDrawerType(undefined));
            dispatch(setMobileDrawerOpen(false));
        }
    }, [token, identity, pusherChannel, eventId, pusherSingleton]);
    useEffect(function () {
        if (!isEmpty(identity) &&
            token &&
            eventId &&
            !pusherNotificationChannel &&
            eventHasNotifications &&
            !isModerator &&
            !isChairman &&
            pusherSingleton) {
            setPusherNotificationChannel(subscribeToPusherNotificationChannel({
                pusherSingleton: pusherSingleton,
                subscriberId: identity.subscription.code,
                callback: function (notification) {
                    if (eventId === notification.event_code)
                        dispatch(addNotification(notification));
                }
            }));
        }
        else if (pusherNotificationChannel && !token) {
            try {
                pusherNotificationChannel.unsubscribe();
            }
            catch (_a) { }
            setPusherNotificationChannel(null);
        }
    }, [token, identity, pusherNotificationChannel, eventId, eventHasNotifications, isModerator, isChairman, pusherSingleton]);
    useEffect(function () {
        if (!isEmpty(identity) && token && eventId && !pusherEvaluationFormChannel && !isModerator && !isChairman && pusherSingleton) {
            setPusherEvaluationFormChannel(subscribeToEvaluationFormPusherChannel({
                config: { appId: eventId },
                evaluationFormEnableCallback: function (status) {
                    dispatch(setEvaluationFormEnableStatusList(status.actions));
                },
                evaluationFormPopupOpenCallback: function (status) {
                    dispatch(setEvaluationFormPopupOpenList(status.actions));
                }
            }));
        }
        else if (pusherEvaluationFormChannel && !token) {
            try {
                pusherEvaluationFormChannel.unsubscribe();
            }
            catch (_a) { }
            setPusherEvaluationFormChannel(null);
        }
    }, [token, identity, pusherEvaluationFormChannel, isModerator, isChairman, pusherSingleton]);
    useEffect(function () {
        if (playerChannelActions)
            setPlayerChannelActions(null);
    }, [setPlayerChannelActions]);
    // Resetting the counter if user is not auth
    useEffect(function () {
        if (!token && !identity.email) {
            setConnectedCounter(0);
        }
    }, [token, identity]);
    // Detect blocked (firewall, VPN, corporate network) or connection failed: it must not look like an unpublished event
    // (contents are not available here, they are fetched with the event id returned by detect)
    if (loadingDetect === "failed" && detectErrorType === DetectErrorType.unreachable)
        return (_jsx(ErrorPage, { icon: _jsx(WarningOutlined, {}), content: _jsxs(_Fragment, { children: ["We are unable to load this page.", _jsx("br", {}), "If you are using a VPN or a corporate network, please disable it or try another connection."] }) }));
    // Coming soon will be displayed if the event does not exist or is not published
    if (isAppPublished === false || loadingDetect === "failed")
        return _jsx(ErrorPage, { content: contents.error_app_not_available || "Coming soon" });
    if (maintenance)
        return _jsx(MaintenancePage, {});
    if (goToForcedPasswordChange)
        return _jsx(Navigate, { to: Paths.changePassword, replace: true });
    else if (goToChairmanRoute)
        return _jsx(Navigate, { to: "".concat(Paths.chairman).concat(search), replace: true });
    else if (goToModeratorRoute)
        return _jsx(Navigate, { to: "".concat(Paths.moderator).concat(search) });
    else if (goToWatchPlayerRoute)
        return _jsx(Navigate, { to: "".concat(Paths.watchPlayer).concat(search) });
    else if (goToEpisodeProposalRoute)
        return _jsx(Navigate, { to: "".concat(Paths.watch).concat(search) });
    return (_jsxs(_Fragment, { children: [_jsx(ScrollToTop, {}), _jsx(Spin, { spinning: isLoading || loadingLogin === "pending", fullPage: true }), _jsx(ModalsConnect, {}), chatVendor === 1 && typeof chatLicense === "string" && !isModerator && !isChairman && (_jsx(LiveChatWidget, { license: chatLicense, customerName: identity.lastname || identity.firstname ? "".concat(identity.lastname, ", ").concat(identity.firstname) : "Utente", customerEmail: identity.email || "Utente", visibility: "minimized" })), _jsxs(Routes, { children: [_jsx(Route, { path: Paths.home, element: !isLoadingMe && !isLoadingDetect && _jsx(HomePage, {}) }), _jsx(Route, { path: "".concat(Paths.unsubscribe, "/:unsubscribeHash"), element: !isLoading && _jsx(UnsubscribePage, {}) }), _jsx(Route, { path: Paths.resetPassword, element: !isLoading && _jsx(ResetPasswordPage, {}) }), _jsx(Route, { path: Paths.changePassword, element: !isLoading && _jsx(ChangePasswordPage, {}) }), isLoggedIn && (_jsxs(_Fragment, { children: [_jsxs(Route, __assign({ element: _jsx(PageLayout, {}) }, { children: [_jsx(Route, { path: Paths.watch, element: _jsx(EpisodeProposalPage, { playerChannelAction: playerChannelActions }) }), _jsx(Route, { path: Paths.watchPlayer, element: _jsx(EpisodeSelectedWrapper, { children: !isLoadingRegisterSelectedEpisode &&
                                                (shouldRenderWaitingRoom ? (_jsx(WaitingRoomPage, {})) : shouldRenderConference ? (_jsx(ConferencePage, { conferenceId: channel === null || channel === void 0 ? void 0 : channel.conference_id, conferenceVendor: channel === null || channel === void 0 ? void 0 : channel.conference_vendor, conferencePassword: channel === null || channel === void 0 ? void 0 : channel.conference_password })) : (_jsx(WatchPage, { pusherSingleton: pusherSingleton }))) }) })] })), _jsx(Route, { path: Paths.moderator, element: isModerator ? _jsx(ModeratorPage, {}) : _jsx(Navigate, { replace: true, to: Paths.watch }) }), _jsx(Route, { path: Paths.chairman, element: isChairman ? _jsx(ChairmanPage, {}) : _jsx(Navigate, { replace: true, to: Paths.watch }) })] })), _jsx(Route, { path: "".concat(Paths.pageDetail, "/:slug/:foid?"), element: _jsx(PageDetailPage, {}) }), _jsx(Route, { path: Paths.videotest, element: _jsx(VideotestPage, {}) }), _jsx(Route, { path: Paths.publicQandA, element: _jsx(PublicQandAPage, {}) }), _jsx(Route, { path: "*", element: _jsx(Navigate, { to: "".concat(Paths.home).concat(search ? search : "") }) })] })] }));
};
